import { render, staticRenderFns } from "./MedicalRepRates.vue?vue&type=template&id=45c1ee41&scoped=true"
import script from "./MedicalRepRates.vue?vue&type=script&lang=js"
export * from "./MedicalRepRates.vue?vue&type=script&lang=js"
import style0 from "./MedicalRepRates.vue?vue&type=style&index=0&id=45c1ee41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1ee41",
  null
  
)

export default component.exports